jQuery(document).ready(function ($) {
  $('.m-language-selector__current').click(function() {
    $(this).siblings().toggleClass('open');
  });
});
